import { useIntl } from 'react-intl';

import { DotsLoader } from '../loader/dots/DotsLoader';

import style from './WemapLoading.module.css';

export function WemapLoading() {
    const { formatMessage } = useIntl();

    return (
        <div className={style.loading}>
            {formatMessage({ id: 'global.component.map.loading' })}
            <DotsLoader />
        </div>
    );
}
